import React from 'react';
import FlexibleHeroProps from './FlexibleHero.props';
import FlexibleHeroWrapper from './FlexibleHeroWrapper';
import { HeaderTextBlock, Hero, MiniCtaGroup } from '@greystar/designsystem';
import { IconName } from '../../component-props';

const FlexibleHero = (props: FlexibleHeroProps) => {
  return (
    <FlexibleHeroWrapper {...props}>
      <Hero hasPadding={props.bodyTextIndentation}>
        <Hero.Tags>
          <MiniCtaGroup ctas={props.SxaTags || []} />
        </Hero.Tags>
        <Hero.Image>{props.image}</Hero.Image>
        <Hero.HeaderTextBlock direction={props.reverse}>
          <HeaderTextBlock.Header
            header={props.heading}
            variant={props.headingColor}
            as={props?.headingStyles}
          />
          <HeaderTextBlock.Subtitle subtitle={props.title} variant={props.titleColor} />
        </Hero.HeaderTextBlock>
        {props.bodyText ? (
          <Hero.BodyCopy iconName={props.icon as IconName}>{props.bodyText}</Hero.BodyCopy>
        ) : (
          <></>
        )}
      </Hero>
    </FlexibleHeroWrapper>
  );
};

export default FlexibleHero;
